/* eslint-disable */
export const user = {
    id: 'cfaad35d-07a3-4447-a6c3-d8c3d54fd5df',
    name: 'Jaume López',
    email: 'jaume.lopez@refactoriza.es',
    avatar: 'images/avatars/jaume-lopez.jpg',
    status: 'online',
};
